import { HStack, Text, VStack, Icon, Flex, Box } from '@chakra-ui/react'
import React from 'react'
import Video from './Video'
import { VscChevronLeft, VscChevronRight } from 'react-icons/vsc'

const CHEVRON_SIZE = 28
const SLIDE_WIDTH = 290
type VideoSliderProps = {
  groupedVideos: any
}
const VideoSlider: React.FC<VideoSliderProps> = ({ groupedVideos }) => {
  const [slideIndex, setSlideIndex] = React.useState(0)

  return (
    <VStack alignItems="flex-start" spacing={5}>
      {Object.keys(groupedVideos).map((category) => (
        <Box key={category} w="100%">
          <HStack gap={2} mb={3}>
            <Box w="12px" h="1px" bg="gray.900" />
            <Text
              fontSize="10px"
              textTransform="uppercase"
              letterSpacing="0.15em"
              color="gray.400"
              fontWeight="600"
            >
              {category.split('_').join(' ')}
            </Text>
          </HStack>
          <Flex align="center" position="relative">
            {slideIndex > 0 && (
              <Flex
                as="button"
                align="center"
                justify="center"
                position="absolute"
                left={0}
                zIndex={10}
                w={`${CHEVRON_SIZE}px`}
                h={`${CHEVRON_SIZE}px`}
                bg="white"
                border="1px solid"
                borderColor="gray.200"
                borderRadius={0}
                cursor="pointer"
                transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
                _hover={{ borderColor: 'gray.900', shadow: 'sm' }}
                onClick={() => {
                  setSlideIndex(slideIndex - 1)
                }}
              >
                <Icon as={VscChevronLeft} boxSize={4} color="gray.600" />
              </Flex>
            )}
            <Flex overflow="hidden" w="100%">
              <Flex
                transform={`translateX(-${slideIndex * SLIDE_WIDTH}px)`}
                transition="transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
                gap={3}
              >
                {groupedVideos[category].map((video: any, index: number) => (
                  <Video video={video} key={index} flexShrink={0} />
                ))}
              </Flex>
            </Flex>
            {slideIndex < groupedVideos[category].length - 1 && (
              <Flex
                as="button"
                align="center"
                justify="center"
                position="absolute"
                right={0}
                zIndex={10}
                w={`${CHEVRON_SIZE}px`}
                h={`${CHEVRON_SIZE}px`}
                bg="white"
                border="1px solid"
                borderColor="gray.200"
                borderRadius={0}
                cursor="pointer"
                transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
                _hover={{ borderColor: 'gray.900', shadow: 'sm' }}
                onClick={() => {
                  setSlideIndex(slideIndex + 1)
                }}
              >
                <Icon as={VscChevronRight} boxSize={4} color="gray.600" />
              </Flex>
            )}
          </Flex>
        </Box>
      ))}
    </VStack>
  )
}

export default VideoSlider
